"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderNumberOfRounds = void 0;
const getOrderNumberOfRounds = (order) => {
    if (!order)
        return 0;
    const variant = order?.variants?.find((variant) => {
        return variant.id === order.default_variant_id;
    });
    if (!variant)
        return 0;
    if (!variant.order_lines)
        return 0;
    return variant.order_lines.filter((orderLine) => {
        return orderLine.type === "GOLF";
    }).length;
};
exports.getOrderNumberOfRounds = getOrderNumberOfRounds;
